module.exports = "/assets/afd6d3cfcc6594e285df9407e0f035c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JU.png
// module id = 1523
// module chunks = 0